import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Admin Pages only
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminSites from "./pages/AdminSites";
import AdminSiteDetail from "./pages/AdminSiteDetail";
import AdminCrews from "./pages/AdminCrews";
import AdminClients from "./pages/AdminClients";
import AdminVehicles from "./pages/AdminVehicles";
import AdminInstruments from "./pages/AdminInstruments";
import AdminAttendance from "./pages/AdminAttendance";
import AdminExpenses from "./pages/AdminExpenses";
import AdminDrawings from "./pages/AdminDrawings";
import AdminSiteDrawings from "./pages/AdminSiteDrawings";
import AdminBills from "./pages/AdminBills";
import AdminBillEditor from "./pages/AdminBillEditor";
import AdminBillDetail from "./pages/AdminBillDetail";
import AdminInquiries from "./pages/AdminInquiries";
import AdminSitesMap from "./pages/AdminSitesMap";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  // Only admin can use this app
  if (user.role !== "admin") {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return <Navigate to="/login" replace />;
  }
  return <Navigate to="/admin" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="top-center"
          containerStyle={{ top: 16, right: 16, left: 16 }}
          toastOptions={{
            duration: 3200,
            style: {
              background: "#ffffff",
              color: "#0f172a",
              border: "1px solid #e6ebf2",
              borderRadius: "14px",
              boxShadow: "0 8px 24px -6px rgb(16 24 40 / 0.14), 0 2px 6px -1px rgb(16 24 40 / 0.06)",
              fontSize: "14px",
              fontWeight: 500,
              padding: "12px 14px",
              maxWidth: "420px",
            },
            success: { iconTheme: { primary: "#10b981", secondary: "#ffffff" } },
            error: { duration: 4500, iconTheme: { primary: "#ef4444", secondary: "#ffffff" } },
            loading: { iconTheme: { primary: "#2563eb", secondary: "#ffffff" } },
          }}
        />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<LoginPage />} />

          <Route path="/admin" element={<ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/sites" element={<ProtectedRoute requiredRole="admin"><AdminSites /></ProtectedRoute>} />
          <Route path="/admin/sites/:id" element={<ProtectedRoute requiredRole="admin"><AdminSiteDetail /></ProtectedRoute>} />
          <Route path="/admin/crews" element={<ProtectedRoute requiredRole="admin"><AdminCrews /></ProtectedRoute>} />
          <Route path="/admin/clients" element={<ProtectedRoute requiredRole="admin"><AdminClients /></ProtectedRoute>} />
          <Route path="/admin/vehicles" element={<ProtectedRoute requiredRole="admin"><AdminVehicles /></ProtectedRoute>} />
          <Route path="/admin/instruments" element={<ProtectedRoute requiredRole="admin"><AdminInstruments /></ProtectedRoute>} />
          <Route path="/admin/attendance" element={<ProtectedRoute requiredRole="admin"><AdminAttendance /></ProtectedRoute>} />
          <Route path="/admin/expenses" element={<ProtectedRoute requiredRole="admin"><AdminExpenses /></ProtectedRoute>} />
          <Route path="/admin/drawings" element={<ProtectedRoute requiredRole="admin"><AdminDrawings /></ProtectedRoute>} />
          <Route path="/admin/sites/:siteId/drawings" element={<ProtectedRoute requiredRole="admin"><AdminSiteDrawings /></ProtectedRoute>} />
          <Route path="/admin/bills" element={<ProtectedRoute requiredRole="admin"><AdminBills /></ProtectedRoute>} />
          <Route path="/admin/bills/new" element={<ProtectedRoute requiredRole="admin"><AdminBillEditor /></ProtectedRoute>} />
          <Route path="/admin/bills/:id" element={<ProtectedRoute requiredRole="admin"><AdminBillDetail /></ProtectedRoute>} />
          <Route path="/admin/bills/:id/edit" element={<ProtectedRoute requiredRole="admin"><AdminBillEditor /></ProtectedRoute>} />
          <Route path="/admin/inquiries" element={<ProtectedRoute requiredRole="admin"><AdminInquiries /></ProtectedRoute>} />
          <Route path="/admin/locations" element={<ProtectedRoute requiredRole="admin"><AdminSitesMap /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
